var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { autorun } from "mobx";
import { observer } from "mobx-react";
import { getStyles } from "./VSplit.styles";
import { getClassNames } from "./VSplit.classNames";
import { ComponentFactory } from "./ComponentFactory";
import { css } from "@uifabric/utilities";
var VSplit = /** @class */ (function (_super) {
    __extends(VSplit, _super);
    function VSplit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._resize = function (e) {
            var minItemHeight = _this.props.vsplit.minItemHeight;
            var bounds = _this._ref.getBoundingClientRect();
            var splitterBounds = _this._splitterRef.getBoundingClientRect();
            var max = bounds.height - splitterBounds.height - minItemHeight;
            var splitterPos = e.clientY - bounds.top;
            if (splitterPos <= minItemHeight) {
                splitterPos = minItemHeight;
            }
            else if (splitterPos >= max) {
                splitterPos = max;
            }
            var offset = splitterPos / bounds.height;
            _this.props.vsplit.setOffset(offset);
        };
        _this._onDocumentMouseUp = function (e) {
            _this._ref.ownerDocument.removeEventListener("mousemove", _this._onDocumentMouseMove);
            _this._ref.ownerDocument.removeEventListener("mouseup", _this._onDocumentMouseUp);
            _this.props.vsplit.setSplitActive(false);
        };
        _this._onDocumentMouseMove = function (e) {
            e.preventDefault();
            _this._resize(e);
        };
        _this._onSplitterMouseDown = function (e) {
            e.preventDefault();
            _this._ref.ownerDocument.addEventListener("mousemove", _this._onDocumentMouseMove);
            _this._ref.ownerDocument.addEventListener("mouseup", _this._onDocumentMouseUp);
            _this.props.vsplit.setSplitActive(true);
        };
        _this._onRef = function (ref) {
            _this._ref = ref;
        };
        _this._onSplitterRef = function (ref) {
            _this._splitterRef = ref;
        };
        _this._onTopPaneRef = function (ref) {
            _this._topPaneRef = ref;
        };
        _this._onBottomPaneRef = function (ref) {
            _this._bottomPaneRef = ref;
        };
        _this._onResize = function () {
            var bounds = _this._ref.getBoundingClientRect();
            var splitterBounds = _this._splitterRef.getBoundingClientRect();
            var topHeight = Math.floor(bounds.height * _this.props.vsplit.offset);
            var bottomHeight = bounds.height - topHeight - splitterBounds.height;
            _this._topPaneRef.style.height = topHeight + "px";
            _this._splitterRef.style.top = _this._topPaneRef.style.height;
            _this._bottomPaneRef.style.height = bottomHeight + "px";
            if (_this.props.vsplit.top) {
                _this.props.vsplit.top.emit({ type: "resize" });
            }
            if (_this.props.vsplit.bottom) {
                _this.props.vsplit.bottom.emit({ type: "resize" });
            }
        };
        return _this;
    }
    VSplit.prototype.componentDidMount = function () {
        this._offsetReactionDisposer = autorun(this._onResize);
        this.props.vsplit.addEventListener("resize", this._onResize);
    };
    VSplit.prototype.componentWillUnmount = function () {
        if (this._offsetReactionDisposer) {
            this._offsetReactionDisposer();
            delete this._offsetReactionDisposer;
        }
        this.props.vsplit.removeEventListener("resize", this._onResize);
    };
    VSplit.prototype.render = function () {
        var classNames = getClassNames(getStyles(null, this.props.styles), this.props.className);
        var top = this.props.vsplit.top;
        var bottom = this.props.vsplit.bottom;
        var topContent = ComponentFactory(top);
        var bottomContent = ComponentFactory(bottom);
        return (React.createElement("div", { className: classNames.root, ref: this._onRef },
            React.createElement("div", { className: classNames.topPane, ref: this._onTopPaneRef, style: { height: "50%" } },
                React.createElement("div", { className: classNames.topContent }, topContent)),
            React.createElement("div", { className: css(classNames.splitter, { active: this.props.vsplit.splitActive }), onMouseDown: this._onSplitterMouseDown, ref: this._onSplitterRef },
                React.createElement("div", { className: css(classNames.splitterContent, { active: this.props.vsplit.splitActive }) })),
            React.createElement("div", { className: classNames.bottomPane, ref: this._onBottomPaneRef, style: { height: "50%" } },
                React.createElement("div", { className: classNames.bottomContent }, bottomContent))));
    };
    VSplit = __decorate([
        observer
    ], VSplit);
    return VSplit;
}(React.Component));
export { VSplit };
